module.exports = __webpack_public_path__ + "static/media/bannerBlog.c0ffc345.jpg";